export default "__VITE_ASSET__C5eg8r_X__"